import moment from 'moment'

import { api } from '../../services/api'
import { getAge, isExpired } from '../../services/helpers'
import { showError, showSuccess } from '../misc/misc.actions'

export const updateParkingCode = (obj) => {
	return (dispatch) => {
		return api	
			.put('/facilities/parkingCodes', obj)
			.then((res) => {
				let codes = res.data 
				dispatch({ type: 'SET_PARKING_CODES', payload: codes })
			})
			.catch(e => {
				console.log('no codes...', e)
			})
	}
}

export const getParkingCodes = (checkin_id) => {
	return (dispatch) => {
		return api	
			.get(`/facilities/parkingCodes?checkin_id=${checkin_id}`)
			.then((res) => {
				let codes = res.data 
				dispatch({ type: 'SET_PARKING_CODES', payload: codes })
			})
			.catch(e => {
				console.log('no codes...', e)
			})
	}
}

export const addCheckIn = (obj) => {
	return (dispatch) => {
		dispatch({ type: 'ADDING_CHECKIN' })

		return api
			.post(`/checkIn`, obj)
			.then((response) => {
				let hasIssues = false
				let hasPetIssues = false

				const checkIn = {
					...response.data,
					accounts: response.data.accounts
						.filter((a) => !!a)
						.map((a) => {
							const issues = accountIssues(a)
							if (issues && issues.length) hasIssues = true

							return {
								...a,
								issues
							}
						}),
					pets: response.data.pets.map((p) => {
						const issues = dogHasIssues(p)
						if (issues && issues.length) {
							hasIssues = true
							hasPetIssues = true
						}

						return {
							...p,
							issues
						}
					}),
					hasIssues,
					hasPetIssues
				}

				dispatch({ type: 'ADDING_CHECKIN_SUCCESS', payload: checkIn })
				dispatch(showSuccess('Check-in created successfully!'))
			})
			.catch((e) => {
				dispatch({ type: 'ADDING_CHECKIN_FAILURE' })
				dispatch(showError('An error occured while creating a check-in.'))
			})
	}
}

export const removeCheckIn = (id) => {
	return (dispatch) => {
		return api
			.delete(`/checkIn/${id}`)
			.then((response) => {
				dispatch({ type: 'REMOVE_CHECKIN_SUCCESS', payload: id })
				dispatch(showSuccess('Check-in removed successfully!'))
			})
			.catch(() => {
				dispatch(showError('An error occured while removing the select check-in.'))
			})
	}
}

export const addNewVisitor = (obj) => {
	return (dispatch) => {
		dispatch({ type: 'CHECKIN_LOADING' })

		return api
			.put(`/checkIns/addVisitor`, obj)
			.then((res) => {
				let hasIssues = false
				let hasPetIssues = false
				const petIssues = []
				const c = {
					...res.data,
					accounts: res.data.accounts
						.filter((a) => !!a)
						.map((a) => {
							const issues = accountIssues(a)
							if (issues && issues.length) hasIssues = true

							return {
								...a,
								issues
							}
						}),
					pets: res.data.pets.map((p) => {
						const issues = dogHasIssues(p)
						if (issues && issues.length) {
							hasIssues = true
							hasPetIssues = true
						}

						return {
							...p,
							issues
						}
					}),
					guests: res.data.guests.map((g) => {
						if (g._id) {
							return {
								...g,
								issues: accountIssues(g),
								dogs: g?.dogs?.map(d => {
									return {
										...d,
										issues: dogHasIssues(d)
									}
								}) || []
							}
						} else {
							return g
						}
					}),
					hasIssues,
					hasPetIssues
				}
				dispatch({ type: 'REPLACE_CHECKIN', payload: c })
				dispatch({ type: 'CHECKIN_NOT_LOADING' })
			})
			.catch((e) => {
				console.log('big ol e here....', e)
				dispatch({ type: 'CHECKIN_NOT_LOADING' })
				dispatch(showError('Error Adding Visitor'))
			})
	}
}

export const removePet = (obj) => {
	return (dispatch) => {
		dispatch({ type: 'CHECKIN_LOADING' })

		return api
			.put(`/checkIns/removePet`, obj)
			.then((res) => {
				let hasIssues = false
				let hasPetIssues = false
				const c = {
					...res.data,
					accounts: res.data.accounts
						.filter((a) => !!a)
						.map((a) => {
							const issues = accountIssues(a)
							if (issues && issues.length) hasIssues = true

							return {
								...a,
								issues
							}
						}),
					pets: res.data.pets.map((p) => {
						const issues = dogHasIssues(p)
						if (issues && issues.length) {
							hasIssues = true
							hasPetIssues = true
						}

						return {
							...p,
							issues
						}
					}),
					guests: res.data.guests.map((g) => {
						if (g._id) {
							return {
								...g,
								issues: accountIssues(g),
								dogs: g?.dogs?.map(d => {
									return {
										...d,
										issues: dogHasIssues(d)
									}
								}) || []
							}
						} else {
							return g
						}
					}),
					hasIssues,
					hasPetIssues
				}
				dispatch({ type: 'REPLACE_CHECKIN', payload: c })
				dispatch({ type: 'CHECKIN_NOT_LOADING' })
			})
			.catch((e) => {
				console.log('big ol e here....', e)
			})
	}
}

export const removeGuest = (obj) => {
	return (dispatch) => {
		dispatch({ type: 'CHECKIN_LOADING' })

		return api
			.put(`/checkIns/removeGuest`, obj)
			.then((res) => {
				let hasIssues = false
				let hasPetIssues = false
				const c = {
					...res.data,
					accounts: res.data.accounts
						.filter((a) => !!a)
						.map((a) => {
							const issues = accountIssues(a)
							if (issues && issues.length) hasIssues = true

							return {
								...a,
								issues
							}
						}),
					pets: res.data.pets.map((p) => {
						const issues = dogHasIssues(p)
						if (issues && issues.length) {
							hasIssues = true
							hasPetIssues = true
						}

						return {
							...p,
							issues
						}
					}),
					guests: res.data.guests.map((g) => {
						if (g._id) {
							return {
								...g,
								issues: accountIssues(g),
								dogs: g?.dogs?.map(d => {
									return {
										...d,
										issues: dogHasIssues(d)
									}
								}) || []
							}
						} else {
							return g
						}
					}),
					hasIssues,
					hasPetIssues
				}
				dispatch({ type: 'REPLACE_CHECKIN', payload: c })
				dispatch({ type: 'CHECKIN_NOT_LOADING' })
			})
			.catch((e) => {
				console.log('big ol e here....', e)
			})
	}
}

export const removeAccount = (obj) => {
	return (dispatch) => {
		dispatch({ type: 'CHECKIN_LOADING' })

		return api
			.put(`/checkIns/removeAccount`, obj)
			.then((res) => {
				let hasIssues = false
				let hasPetIssues = false
				const c = {
					...res.data,
					accounts: res.data.accounts
						.filter((a) => !!a)
						.map((a) => {
							const issues = accountIssues(a)
							if (issues && issues.length) hasIssues = true

							return {
								...a,
								issues
							}
						}),
					pets: res.data.pets.map((p) => {
						const issues = dogHasIssues(p)
						if (issues && issues.length) {
							hasIssues = true
							hasPetIssues = true
						}

						return {
							...p,
							issues
						}
					}),
					guests: res.data.guests.map((g) => {
						if (g._id) {
							return {
								...g,
								issues: accountIssues(g),
								dogs: g?.dogs?.map(d => {
									return {
										...d,
										issues: dogHasIssues(d)
									}
								}) || []
							}
						} else {
							return g
						}
					}),
					hasIssues,
					hasPetIssues
				}
				dispatch({ type: 'REPLACE_CHECKIN', payload: c })
				dispatch({ type: 'CHECKIN_NOT_LOADING' })
			})
			.catch((e) => {
				console.log('big ol e here....', e)
			})
	}
}

export const completeCheckIn = (obj) => {
	return (dispatch) => {
		dispatch({ type: 'CHECKIN_LOADING' })

		return api
			.put(`/checkIns/complete/${obj._id}`, obj)
			.then((res) => {
				let hasIssues = false
				let hasPetIssues = false
				const c = {
					...res.data,
					accounts: res.data.accounts
						.filter((a) => !!a)
						.map((a) => {
							const issues = accountIssues(a)
							if (issues && issues.length) hasIssues = true

							return {
								...a,
								issues
							}
						}),
					pets: res.data.pets.map((p) => {
						const issues = dogHasIssues(p)
						if (issues && issues.length) {
							hasIssues = true
							hasPetIssues = true
						}

						return {
							...p,
							issues
						}
					}),
					guests: res.data.guests.map((g) => {
						if (g._id) {
							return {
								...g,
								issues: accountIssues(g),
								dogs: g?.dogs?.map(d => {
									return {
										...d,
										issues: dogHasIssues(d)
									}
								}) || []
							}
						} else {
							return g
						}
					}),
					hasIssues,
					hasPetIssues
				}
				dispatch({ type: 'REPLACE_CHECKIN', payload: c })
				dispatch({ type: 'CHECKIN_NOT_LOADING' })
			})
			.catch((e) => {
				console.log('big ol e here....', e)
			})
	}
}

export const guestSigned = (guest, checkIn) => {
	return (dispatch) => {
		dispatch({
			type: 'GUEST_SIGNED',
			payload: { guest, checkIn }
		})
		const obj = {
			guests: checkIn.guests.map((g) => {
				if (g.name === guest.name)
					return {
						name: g.name,
						signed_waiver: !g.signed_waiver
					}

				return g
			})
		}

		return api
			.put(`/checkIns/guestSigned/${checkIn._id}`, obj)
			.then((res) => {
				dispatch({ type: 'CHECKIN_NOT_LOADING' })
			})
			.catch((e) => {
				console.log('big ol e here....', e)
			})
	}
}

export const getCheckInsByFacilityId = (facility, date) => {
	return (dispatch) => {
		dispatch({ type: 'GET_CHECKINS' })

		return api
			.get(`/facilities/${facility._id}/checkIns?date=${date}`)
			.then((res) => {
				const ours = res.data.map((c) => {
					// c.accounts.forEach((acct, i) => {
					//   if (!acct) console.log("BAD ONE....", c);
					// });

					let hasIssues = false
					let hasPetIssues = false

					return {
						...c,
						accounts: c.accounts
							.filter((a) => !!a)
							.map((a) => {
								const issues = accountIssues(a)
								if (issues && issues.length) {
									hasIssues = true
								}

								return {
									...a,
									issues
								}
							}),
						pets: c.pets.map((p) => {
							const issues = dogHasIssues(p)
							if (issues && issues.length) {

								hasIssues = true
								hasPetIssues = true
							}

							return {
								...p,
								issues
							}
						}),
						guests: c.guests.map((g) => {
							if (g._id) {

								const acctIssues = accountIssues(g)
								if (acctIssues && acctIssues.length) {
									hasIssues = true
								}

								return {
									...g,
									issues: acctIssues,
									signed_waiver: g?.ID_info?.waiver_expiration_date ? true : g.signed_waiver,
									dogs: g?.dogs?.map(d => {

										const dogIssues = dogHasIssues(d)
										if (dogIssues.length) {
											hasIssues = true
											hasPetIssues = true
										}

										return {
											...d,
											issues: dogIssues
										}
									}) || []
								} 
							} else {
								return g
							}
						}),
						hasIssues,
						hasPetIssues
					}
				})

				// console.log("ours...", ours);
				dispatch({ type: 'SET_CHECKINS', payload: ours })
			})
			.catch((error) => {
				console.log('err.....', error)
				dispatch({ type: 'GET_CHECKINS_FAIL', payload: error })
			})
	}
}

const accountIssues = (account) => {
	const issues = []
	if (!account) return []
	if (!account.ID_info || !account.ID_info.first_name || !account.ID_info.expiration_date || !account?.ID_info?.waiver_expiration_date) {
		issues.push({
			message: `Missing photo ID or signed waiver`
		})
	}

	if (!account.terms_of_service) issues.push({ message: 'Needs to verify their account' })
	if (account.ID_info && account.ID_info.expiration_date) {
		if (moment().isAfter(moment(account.ID_info.expiration_date)))
			issues.push({
				message: `ID is expired`
			})
	}

	return issues
}

const dogHasIssues = (pet) => {
	try {
		if (!pet) return []

		const issues = []

		const missingVaccines = []

		required_vaccines.forEach((vax, i) => {
			const findVax = pet.vaccines.find((v) => v.id === vax.id || v.type === vax.name || v.name === vax.name)
			if (!findVax) {
				missingVaccines.push(true)
			} else if (isExpired(findVax)) {
				issues.push({
					message: `${vax.name} vaccine expired.`,
					secondary: 'Contact us or see us at the front desk upon arrival ',
					type: 'vaccine',
					type: 'danger'
				})
			} else if (!findVax.valid) {
				missingVaccines.push(true)
			}
		})

		if (missingVaccines.some((v) => v)) issues.push({ message: `Unverified Vaccines` })

		const age_in_days = getAge(pet)

		const valid_sexes = ['Neutered Male', 'Spayed Female']
		const sex = pet.sex
		let validAgeSex

		if (age_in_days < 112) {
			issues.push({
				message: `${pet.name} is under the age requirement.`,
				secondary: 'Dogs must be at least 16 weeks old',
				type: 'red'
			})
		} else if (age_in_days < 180) {
			validAgeSex = true
		} else {
			if (
				valid_sexes.includes(pet.sex) ||
				(pet.spay_neuter_deadline && moment().isBefore(pet.spay_neuter_deadline))
			) {
				// dont do anything...
			} else {
				issues.push({
					message: `${pet.name.trim()} must be spayed or neutered.`,
					secondary: 'Dogs over 6 months old must be spayed or neutered.',
					type: 'red'
				})
			}
		}
		if (pet.temporary_service_restrictions?.includes('Bar & Park'))
			issues.push({ message: `Temporarily banned`, type: 'red' })
		if (pet.permanent_service_restrictions?.includes('Bar & Park'))
			issues.push({ message: `Permanently banned`, type: 'red' })

		return issues
	} catch (e) {
		console.log('badon here...', e)

		return []
	}
}

const required_vaccines = [
	{ name: 'Rabies', id: 1 },
	{ name: 'Bordetella', id: 2 },
	{ name: 'Distemper & Parvovirus', id: 3 }
]
